import { render, staticRenderFns } from "./BurgerMenuMobile.vue?vue&type=template&id=2edc6759&"
import script from "./BurgerMenuMobile.vue?vue&type=script&lang=js&"
export * from "./BurgerMenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports